export const SORT_FILTERS = [
  {
    label: 'Popularity',
    value: 'popularity',
  },
  {
    label: 'Price: Low To High',
    value: 'low-to-high',
  },
  {
    label: 'Price: High To Low',
    value: 'high-to-low',
  },
  {
    label: 'New Arrivals',
    value: 'new_arrivals',
  },
  {
    label: 'Bestseller',
    value: 'bestseller',
  },
  {
    label: 'Discount: High to Low',
    value: 'discount',
  },
  {
    label: 'Fastest Shipping Time',
    value: 'ships_in',
  },
];

export const SORT_BY_TEXT = 'Sort by';
export const SORT_ICON_SIZE = '20px';
